import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

// The logged-in customer's own past orders (drafts excluded), newest first.
// Params: { page, per_page, name, statuses } — `name` searches the order
// number / address / product names, `statuses` is a list of raw status codes
// (axios serializes the array as `statuses[]=A&statuses[]=B`).
export const getOrders = createAsyncThunk(
  "orders/get",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/orders/history/`,
        {
          params,
        }
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

// Quick Reorder preview for one past order: today's prices, stock and totals
// for the same lines. `orderId` is the numeric `id` from the history rows
// (not `order_id`). All-or-nothing: `can_reorder` is false when any line is
// gone, hidden or short on stock, and `totals` is null then.
export const getReorderPreview = createAsyncThunk(
  "orders/reorderPreview",
  async (orderId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/orders/${orderId}/reorder/`
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

// Places the same order again. The server copies items, promo, payment type
// and fulfillment method from the old order and prices it fresh; only an
// optional replacement delivery `address` is sent. 201 answers with the new
// order in the `/orders/history/` row shape.
export const placeReorder = createAsyncThunk(
  "orders/reorderPlace",
  async ({ orderId, address } = {}, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/orders/${orderId}/reorder/`,
        address ? { address } : {}
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
